import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectExternalCost } from "../Model/ProposalProjectExternalCost";

export async function deleteProposalProjectExternalCost(id) {
    let response = await getAPIResponse("/v1/proposal-project-external-cost/"+id, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectExternalCost = ProposalProjectExternalCost.createFromResponseData(response);
    return proposalProjectExternalCost;
}